import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function FlagOutline(props: SvgIconProps) {
  const { color, ...rest } = props;
  return (
    <SvgIcon
      {...rest}
      viewBox='0 0 24 24'
    >
      <path
        d='M5 21V4M5 4V13.5C5 13.5 6.5 12 10 12C13.5 12 15 13.5 15 13.5V4M5 4C5 4 6.5 2.5 10 2.5C13.5 2.5 15 4 15 4M15 4H19V13.5H15'
        stroke={color || 'currentColor'}
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
      />
    </SvgIcon>
  );
}
